<span [satPopoverAnchor]="popover" (click)="popover.toggle()" class="moreinfo"></span>
<sat-popover
    #popover
    verticalAlign="end"
    horizontalAlign="after"
    scrollStrategy="close"
    [autoFocus]="false"
    (opened)="tellParentToCloseAllPopovers()"
    (afterOpen)="afterOpened()"
>
    <div class="tooltip-content">
        <h3>{{ option.callOutInfoHead }}</h3>
        <p>{{ option.callOutInfoText }}</p>
    </div>
</sat-popover>
